import { Component, HostListener, input, OnDestroy, output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

let nextUniqueId = 0;
let nextUniqueDataCy = 0;

@Component({
  selector: 'accredible-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.scss'],
  // We are not using ChangeDetectionStrategy.OnPush because this input component
  // does not detect changes when formGroup.markAllAsTouched() is triggered
})
export class AccredibleCheckboxInputComponent implements OnDestroy {
  formControlRef = input.required<UntypedFormControl>();
  label = input<string>();
  id = `checkbox-${nextUniqueId++}`;
  required = input(false);
  hint = input<string>();
  tabIndex = input<number>();
  disabled = input(false);
  showFullText = input(false);
  dataCy = input<string>(`checkbox-${nextUniqueDataCy++}`);
  color = input<'light-primary' | 'light-secondary' | 'default'>('default');

  checkboxChange = output<boolean>();

  @HostListener('click')
  onClick(): boolean {
    return !this.disabled();
  }

  onChange(event: Event): void {
    event.stopPropagation();
    this.checkboxChange.emit(this.formControlRef().value);
  }

  ngOnDestroy(): void {
    nextUniqueDataCy = 0;
  }
}
